import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class Comments {
	async getComments({ pgid, uid, skip, limit, token }: { pgid: string; uid: string; skip?: string; limit?: string; token?: string }) {
		const r = await xget<PGSchema.private_notes[]>(`/pages/${pgid}/comments/${uid}`, { skip, limit, token });
		return r;
	}

	async postComments(
		{ pgid, uid }: { pgid: string; uid: string },
		body: {
			body: string;
			uids?: string[];
			hashtags?: string[];
			userInfo?: Pick<PGSchema.users, "id" | "name" | "last_name" | "thumb_pp">;
			module?: string;
			jid: number;
			token: string;
		}
	) {
		const r = await xhttp<{ _id: number }>(`/pages/${pgid}/comments/${uid}`, "POST", body);
		return r;
	}

	async editComments({ pgid, uid }: { pgid: string; uid: string }, body: { _id: PGSchema.private_notes["id"]; token?: string }) {
		const r = await xhttp<{ _id: number }>(`/pages/${pgid}/comments/${uid}`, "PATCH", body);
		return r;
	}

	async deleteComments({ pgid, uid }: { pgid: string; uid: string }, body: { _id: PGSchema.private_notes["id"]; token?: string }) {
		const r = await xhttp<{ ok: number }>(`/pages/${pgid}/comments/${uid}`, "DELETE", body);
		return r;
	}
}
